export default __webpack_public_path__ + "static/media/Lock.8c029721.svg";